import React from 'react';

import { CompanyTagsContext } from './CompanyTagsContext';

export const useCompanyTagsContext = () => React.useContext(CompanyTagsContext);
